import { useCallback } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  disconnectQuickBooksFund,
  fetchQuickBooksAuthUri,
  fetchQuickBooksConfig,
} from '../../../services/queries/MaggieIntegrationsQueries';
import { useIntegrationActions } from '../hooks/useIntegrationActions';

export function useQuickBooksConfigActions() {
  const queryClient = useQueryClient();
  const { refetchIntegrations } = useIntegrationActions();

  const { data, isLoading, isError } = useQuery({
    queryKey: ['quickbooks-config'],
    queryFn: fetchQuickBooksConfig,
  });

  const disconnectMutation = useMutation({
    mutationFn: (fundId: number) => disconnectQuickBooksFund(fundId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['quickbooks-config'] });
      await refetchIntegrations();
    },
  });

  const connectFund = useCallback(async (fundId: number) => {
    const { url } = await fetchQuickBooksAuthUri(fundId);
    window.location.assign(url);
  }, []);

  return {
    funds: data?.funds ?? [],
    isLoading,
    isConfigError: isError,
    connectFund,
    disconnectFund: disconnectMutation.mutateAsync,
    isDisconnecting: disconnectMutation.isPending,
  };
}
